import { z } from 'zod';
/** Required non-empty string after trim. Message covers undefined/wrong type and empty/whitespace. */
export function zStringRequired(message = 'Required') {
    return z.string({ message }).trim().min(1, message);
}
/** Required ISO date (`YYYY-MM-DD`). Message covers missing, empty, and invalid format. */
export function zDateRequired(message = 'Required') {
    return z.iso.date({ message });
}
